import { IRequest, IResponseWithArrayBody } from "./base";

/**
 * generic class, file này để định nghĩa các phương thức ban đầu cho
 * file generic service
 */
export abstract class GenericServiceRepository<TRequest extends IRequest, TResponse> {

  abstract create(data: TRequest): Promise<TResponse>;

  abstract createList(data: TRequest): Promise<any>

  abstract findByQuery(query: Record<string, any>): Promise<IResponseWithArrayBody<TResponse>>;

  abstract findById(id: string): Promise<TResponse>;

  abstract patch(id: string, data: TRequest): Promise<TResponse>;

  abstract put(id: string, data: TRequest): Promise<TResponse>;

  abstract delete(id: string): Promise<void>;
}
